import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import SummaryPlayList from '../SummaryPlayList/SummaryPlayList';
import FilterDataContainer from './containers/FilterDataContainer.js';
import {
    SummaryWrapper,
    SummaryPlayListWrapper,
    Divider,
    SummaryPlayCard
} from './summary.style';

const Summary = ({
    isLoading,
    list,
    initialAtBatIndex,
    openAtBatOverlay,
    activeFilters,
    parallaxAdIndex,
    useContainer = false,
    showVideoButton,
    isFinal,
    scrollRef
}) => {
    return (
        <SummaryWrapper>
            <FilterDataContainer isFinal={isFinal} stickyEnabled={!isFinal && useContainer} scrollRef={scrollRef} />
            <Divider />
            <SummaryPlayCard $isTablet={useContainer} $maxHeightOverride='max-content'>
                <SummaryPlayListWrapper>
                    <SummaryPlayList
                        parallaxAdIndex={parallaxAdIndex}
                        openAtBatOverlay={ openAtBatOverlay }
                        initialAtBatIndex={ initialAtBatIndex }
                        isLoading={ isLoading }
                        filters={ activeFilters }
                        playsByInning={ list }
                        showVideoButton={ showVideoButton }
                    />
                </SummaryPlayListWrapper>
            </SummaryPlayCard>
        </SummaryWrapper>
    );
};

Summary.propTypes = {
    isLoading: PropTypes.bool,
    list: PropTypes.array,
    initialAtBatIndex: PropTypes.number,
    openAtBatOverlay: PropTypes.func,
    activeFilters: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    parallaxAdIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    useContainer: PropTypes.bool,
    showVideoButton: PropTypes.bool,
    isFinal: PropTypes.bool,
    scrollRef: PropTypes.object
};

export default withTheme(Summary);
